import { createClient, type SupabaseClientOptions } from "@supabase/supabase-js";

import { getEnv } from "@/hooks/useEnv";
import type { Database } from "@/supabase.types";

const options: SupabaseClientOptions<"public"> = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit",
  },
};

export const client = createClient<Database>(
  getEnv("VITE_SUPABASE_URL") ?? "",
  getEnv("VITE_SUPABASE_KEY") ?? "",
  options,
);

export default client;
